var map = {
	"./bar.svg": 373,
	"./download.svg": 728,
	"./embed.svg": 97,
	"./json.svg": 456,
	"./line.svg": 121,
	"./pie.svg": 313,
	"./reinit.svg": 550,
	"./save.svg": 700,
	"./scatter.svg": 220,
	"./table.svg": 122,
	"./text.svg": 128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;